import commonScripts from './common';
window.addEventListener('load', () => {
  document.querySelector('body').classList.add("loaded")
	commonScripts();
});
